import Swiper, { A11y, Pagination} from 'swiper'

const contextual = document.querySelector('.contextual-publications .js-swiper-container') !== null;

if (contextual) {

    Swiper.use([ A11y, Pagination ]);

    let config = {
        spaceBetween: 30,
        watchOverflow: true, // default
    
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    
        a11y: {
            enabled: true,
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
        },
    }
    
    let swiper = new Swiper('.contextual-publications .js-swiper-container', config);
}

const contextualImage = document.querySelector('.contextual-publications .js-swiper-container--image') !== null;

if (contextualImage) {

    Swiper.use([ A11y, Pagination ]);

    let configImage = {
        slidesPerView: 3,
        spaceBetween: 30,
        watchOverflow: true, // default

        breakpoints: {
            1201: {
                spaceBetween: 30,
            },
            961: {
                spaceBetween: 20,
            },
            641: {
                slidesPerView : 2,
                spaceBetween: 20,
            },
            0: {
                slidesPerView : 1,
                spaceBetween: 20
            }
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        a11y: {
            enabled: true,
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
        },
    }

    let swiper = new Swiper('.contextual-publications .js-swiper-container--image', configImage);
}
